(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(root) {
      if (!root || root.getAttribute('data-sp-hero-ready')) return;
      root.setAttribute('data-sp-hero-ready', 'true');

      var videos = Array.prototype.slice.call(root.querySelectorAll('[data-sp-hero-video]'));
      var toggle = root.querySelector('[data-sp-hero-toggle]');
      if (!videos.length || !toggle) return;

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var userPaused = reduceMotion.matches;

      function activeVideo() {
        for (var i = 0; i < videos.length; i++) {
          if (window.getComputedStyle(videos[i]).display !== 'none') return videos[i];
        }
        return null;
      }

      function render() {
        var video = activeVideo();
        var playing = !!video && !video.paused && !video.ended;
        toggle.setAttribute('data-playing', playing ? 'true' : 'false');
        toggle.setAttribute(
          'aria-label',
          playing ? toggle.getAttribute('data-label-pause') : toggle.getAttribute('data-label-play')
        );
      }

      function play(video) {
        video.muted = true;
        video.preload = 'metadata';
        var promise = video.play();
        if (promise && promise.catch) promise.catch(render);
      }

      function sync() {
        var video = activeVideo();
        videos.forEach(function (item) {
          if (item !== video && !item.paused) item.pause();
        });
        if (video && !userPaused && video.paused) play(video);
        render();
      }

      toggle.hidden = false;

      toggle.addEventListener('click', function () {
        var video = activeVideo();
        if (!video) return;
        if (video.paused) {
          userPaused = false;
          play(video);
        } else {
          userPaused = true;
          video.pause();
        }
        render();
      });

      videos.forEach(function (video) {
        video.addEventListener('play', render);
        video.addEventListener('pause', render);
      });

      window.addEventListener('resize', sync);
      sync();
    }

    function initAll() {
      document.querySelectorAll('[data-sp-hero]').forEach(initHero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target && event.target.querySelector('[data-sp-hero]');
      if (root) initHero(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-page-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function enhance(root) {
      var terms = root.querySelectorAll('dt');
      terms.forEach(function (dt) {
        var dd = dt.nextElementSibling;
        if (!dd || dd.tagName !== 'DD') return;
        dt.setAttribute('role', 'button');
        dt.setAttribute('tabindex', '0');
        dt.setAttribute('aria-expanded', 'false');
        dd.hidden = true;
        function toggle() {
          var open = dt.getAttribute('aria-expanded') === 'true';
          dt.setAttribute('aria-expanded', open ? 'false' : 'true');
          dd.hidden = open;
        }
        dt.addEventListener('click', toggle);
        dt.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggle();
          }
        });
      });
    }

    function init() {
      document.querySelectorAll('[data-sp-faq-legacy]').forEach(function (root) {
        if (root.dataset.spFaqReady) return;
        root.dataset.spFaqReady = 'true';
        enhance(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
